import { useSnackbar } from "notistack";
import SharedPreferences from "../../../core/utils/SharedPreferences";
import { STORAGE_KEYS } from "../../../data/constant/Constants";
import { useState } from "react";
import { LoginUseCase } from "../../../domain/usecase/auth/Login/LoginUseCase";
import { State } from "../../../domain/model/ResponseState";
import { Admin } from "../../../domain/model/Admin";
import { provideGetAdminInfoUseCase } from "../../di/UseCasesModule";

export function LoginViewModel(loginUseCase: LoginUseCase) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  async function login(email: string, password: string) {
    setIsLoading(true);
    const response = await loginUseCase.invoke({
      email,
      password,
      isAdmin: true,
    });
    setIsLoading(false);
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        const role = response.data.role;

        SharedPreferences.setString(STORAGE_KEYS.ROLE, role);
        SharedPreferences.setString(
          STORAGE_KEYS.TOKEN,
          response.data?.accessToken!,
        );

        // if (role == Role.ADMIN) {
        //   const admin = await getAdminInfo();
        //   if (!admin) return;
        // }

        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  async function getAdminInfo(): Promise<Admin | undefined> {
    const response = await provideGetAdminInfoUseCase().invoke();
    switch (response.responseState) {
      case State.Success:
        return response.data;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error",
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return {
    login,
    isLoading,
    setIsLoading,
  };
}
